// 引入axios
import router from './../../router'
import Vue from 'vue'
import promise from 'es6-promise'
import axios from 'axios'
import store from '../../store/index'
// import localStorage from '../storage/localStorage'
import Cookie from 'js-cookie';

// import state from '@/store/state';
promise.polyfill()

const service = axios.create({
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Domain':'50bb44f53b8e4719b0c4ee81dbb7238c',
    
  },
  withCredentials: true,
  timeout: 20000 // 请求超时 20s
})
// console.log('----->',store.state)
// 请求拦截器
service.interceptors.request.use(config => {
  // 是否为当前的请求加上请求头 token
  // if (localStorage.get('token')) {
  //   config.headers['x-auth-token'] = localStorage.get('token')
  // }
  
  //根据不同经营区域携带不同的参数
  config.headers['SHOP-AREA'] = store.state.city_location.value;
  if (Cookie.get('token')) {
    config.headers['Authorization'] = Cookie.get('token')
    config.headers['token'] = Cookie.get('token')
  }
  if (Cookie.get('code')) {
    config.headers['code'] = Cookie.get('code')
  }
  // config.headers['Domain'] = '50bb44f53b8e4719b0c4ee81dbb7238c'
  if(location && location.href && location.href.includes('https')){
    config.url = config.url.replaceAll("http:","https:")
  }
  return config
}, error => {
  return Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    if (response.data.code === '20005' || response.data.code === '20004') {
      store.commit('resetVuex')
      Cookie.remove('token')
      Cookie.remove("needCheckPass")
      router.push({path: '/login'})
    }
    return response
  },
  err => {
    // 失败响应
    if (err && err.response) {
      switch (err.response.status) {
        case 400:
          err.message = err.response.data.message || err.response.data.msg || '请求无效，请检查参数是否正确!'
          break

        case 401:
          err.message = '未经授权，访问被拒!'
          break

        case 403:
          err.message = '拒绝访问!'
          break

        case 404:
          err.message = `地址不存在!`
          break

        case 408:
          err.message = '请求超时!'
          break

        case 500:
          err.message = '系统错误!'
          break

        case 501:
          err.message = '该方法未实现!'
          break

        case 502:
          err.message = '网管出错!'
          break

        case 503:
          err.message = '服务不可用!'
          break

        case 504:
          err.message = '网关请求超时'
          break

        case 505:
          err.message = 'HTTP版本不受支持'
          break

        default:
      }
      if (err.response.data.error) {
        err.message = err.response.data.error
      }
      Vue.prototype.$message.closeAll()
      Vue.prototype.$message.error(err.message)
    }
    return Promise.reject(err)
  }
)
export default service



// WEBPACK FOOTER //
// ./src/config/mixin/server.js